export const theme = {
  colors: {
    primary: '#8B6F5E',
    primaryDark: '#6B4F3E',
    primaryLight: '#A68B7B',
    secondary: '#F2D5D0',
    secondaryLight: '#FAE8E4',
    tertiary: '#E7D4B5',
    accent: '#C49B8A',
    hero: '#9E7E72',
    heroDark: '#7A5C50',
    white: '#FFFFFF',
    cream: '#FFF8F5',
    background: '#FFFAF7',
    cardPink: '#F8E2E0',
    cardCream: '#F5EDE3',
    text: '#3A2E28',
    textLight: '#7A6960',
    textMuted: '#A89890',
    overlay: 'rgba(107, 79, 62, 0.85)',
    dark: '#2C1F1A',
    darkMuted: '#4A3830',
  },
  fonts: {
    heading: "'Playfair Display', Georgia, serif",
    body: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
    wide: '1200px',
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
    section: '5rem',
  },
  borderRadius: {
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    full: '9999px',
  },
  shadows: {
    card: '0 4px 24px rgba(139, 111, 94, 0.08)',
    cardHover: '0 12px 40px rgba(139, 111, 94, 0.15)',
    button: '0 4px 20px rgba(139, 111, 94, 0.25)',
    soft: '0 2px 12px rgba(0, 0, 0, 0.06)',
  },
  transitions: {
    default: '0.3s ease',
    slow: '0.5s ease',
    spring: '0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
  },
} as const;

export type ThemeType = typeof theme;

